import React from "react";
import ExperienceCard from "../components/ExperienceCard";

export default function Experiences() {
  const fillerExperiences = [
    {
      company: "Google",
      position: "Software Engineer Intern",
      date: "Aug 2026 — Nov 2026",
      description: "Incoming Fall 2026 working on Google Cloud Platform infrastructure in Sunnyvale, CA."
    },
    {
      company: "Meta",
      position: "Software Engineer Intern",
      date: "Jun 2026 — Aug 2026",
      description: "Incoming summer 2026 in the Menlo Park HQ, CA."
    },
    {
      company: "Reality Design Studio",
      position: "Spatial Computing Researcher",
      date: "Jan 2023 — Present",
      description: "Senior member of Northeastern lab focused on AR/VR research under Dr. Wallace Lages. Many projects!"
    },
    {
      company: "Handshake AI",
      position: "AI Research Fellow",
      date: "Sep 2025 — Dec 2025",
      description: "Contract work to refine real AI models and applications through validations and testing."
    },
    {
      company: "Khoury College of Computer Sciences",
      position: "CS 3000 Teaching Assistant",
      date: "Sep 2025 — Dec 2025",
      description: "Algorithms and Data Structures. Assisting with course material, grading, and student support."
    },
    {
      company: "Babel Street",
      position: "Software Engineer Co-op",
      date: "Jan 2025 — Jun 2025",
      description: "Developed for NLP Software (SDK, API, Plugins, DevOps, MVPs) used by S&P 500 and Gov organizations."
    },
    {
      company: "Northeastern Virtual Reality",
      position: "President and Tech Lead",
      date: "Apr 2023 — May 2025",
      description: "Transformed club with Agile infrastructure, 6x increase in tech supply, workshops, gamenights, speaker events."
    },
    {
      company: "Flow Fitness",
      position: "UX Research Intern",
      date: "Jun 2024 — Aug 2024",
      description: "Streamlined the signup process for potential customers through research and data-driven designs."
    },
    {
      company: "Northeastern University",
      position: "Orientation Leader",
      date: "Aug 2024 — Sep 2024",
      description: "Supported Foundation Year students, a first year program designed for predominantly first-gen Boston high schoolers."
    },
    {
      company: "Center For Student Involvement (Northeastern)",
      position: "Office Assistant",
      date: "Sep 2022 — Feb 2023",
      description: "Part time work during my first year! Grew my communication skills while learning about university clubs."
    },
    {
      company: "The Calculus Project",
      position: "Math Tutor",
      date: "Jul 2021 — Sep 2021",
      description: "Taught disadvantaged high school students calculus and geometry."
    },
  ];

  return (
    <section className="experience-grid">
      <span className="section-label">03 — Experience</span>
      <h2>Experiences</h2>
      <p className="hero-subtext">It’s the quiet lessons, not just the loud achievements, that shape who we are.</p>
      {fillerExperiences.map((exp, i) => (
        <ExperienceCard key={i} {...exp} />
      ))}
    </section>
  );
}
